import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import CurrencyLogo from 'components/CurrencyLogo'
import I18n from 'components/I18n'
import CloseCircle from 'components/Icons/CloseCircle'
import Row from 'components/Row'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { screenWidth } from 'utils'
import { color } from 'utils/styledHelper'

import { PropsType } from '.'
import Stats from './Stats'

const Icon = styled(CloseCircle)`
  position: absolute;
  top: 1rem;
  right: 1rem;

  &:hover {
    cursor: pointer;
    fill: ${color('white')};
  }
`
const Wrapper = styled(Column)`
  min-height: 19rem;
  max-width: 30rem;
  background: ${color('dark800')};
  border: 4px solid ${color('dark900')};
  border-radius: 0.5rem;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    border-radius: 0;
    max-width: unset;
  }
`
const Header = styled(Row)`
  gap: 1rem;
  padding: 2rem 2.5rem 1.5rem 2.5rem;
  align-items: center;
`
const Logo = styled(CurrencyLogo)`
  background: ${color('white')};
  border-radius: 100%;
`
const Content = styled.div`
  padding: 0 2.5rem;
`
const Title = styled.h2`
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 150%;
  color: ${color('white')};
  margin: 0;
`
const Subtitle = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${color('white')};
  margin: 0;
`
const CTAButton = styled(CeruleanButton)`
  margin: 1.5rem 0 0 0;
  width: 100%;
`

const WhatsNew = ({ currency, hideModal, onClick, smallScreen, symbol, tickerData }: PropsType) => {
  if (!currency) return null
  return (
    <Wrapper>
      {!smallScreen && <Icon data-e2e='Whats_new_close' onClick={hideModal} size='24px' />}
      <Header>
        <Logo currency={currency} size='56px' />
        <Stats currency={currency} tickerData={tickerData} />
      </Header>
      <Content>
        <Title>
          <I18n currency={currency} data={messages.whats_new_modal_title} />
        </Title>
        <Subtitle>
          <I18n currency={currency} data={messages.whats_new_modal_subtitle} />
        </Subtitle>
        <CTAButton onClick={() => onClick(currency, symbol)}>
          <I18n currency={currency} data={messages.whats_new_modal_button} />
        </CTAButton>
      </Content>
    </Wrapper>
  )
}

export default WhatsNew
